import isArray from "lodash/isArray";
import isNumber from "lodash/isNumber";
import isString from "lodash/isString";
import { SimpleChange } from "PFCore/types";
import { TFunction } from "react-i18next";

const isStringOrNumber = (val: unknown) => isString(val) || isNumber(val) || val === null;

export const isSimpleChange = (value: unknown): value is SimpleChange => {
  if (!isArray(value) || value.length !== 2) {
    return false;
  }
  const [first, second] = value;
  return isStringOrNumber(first) && isStringOrNumber(second);
};

export const formatSimpleChange = (key: string, change: SimpleChange, t: TFunction<"core">) => {
  const [before, after] =
    key === "workflowState"
      ? change.map((text) => t(`core:roleStatus.workflowState.${text}` as unknown as TemplateStringsArray))
      : change.map((value) => (value !== null ? String(value) : ""));

  return { before, after };
};
